import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

import Input from "../../shared/components/form/input"
import ListProcedureRow from './ListRow/ListProcedureRow'
import Modal from '../../shared/modal/Modal'
import NewProcedure from './NewProcedure'
import Button from '../../shared/components/Button/Button'
import useMyPermission from '../../hooks/useMyPermission'
import './Procedure.css'

function Procedure() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [procedures, setProcedures] = useState([])
    const [modalNew, setModalNew] = useState(false)
    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)
    const [myPermission, setMyPermission] = useState({ group: "" })

    const { checkPermission } = useMyPermission()
    const myPermissionView = checkPermission(myPermission, "procedure_View")
    const myPermissionCreate = checkPermission(myPermission, "procedure_Create")

    const getAll = () => {
        api.get(`/procedure/getall`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (response) {
                setProcedures(response.data.procedures)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    useEffect(() => { getAll() }, [token])

    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return procedures.filter((item) => (item.name || '').toLowerCase().includes(searchLowerCase))
    }, [procedures, search])

    if (!load) {
        return <div className="pg-loading">Carregando procedimentos...</div>
    }

    if (!myPermissionView) {
        return (
            <div className="pg-empty">
                <p className="pg-empty-title">Sem permissão para visualizar procedimentos</p>
            </div>
        )
    }

    return (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Procedimentos</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionCreate && <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar procedimento..."
                                    value={search}
                                    handleOnChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'procedimento' : 'procedimentos'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListProcedureRow dataArray={filter} handleOnSuccess={getAll} myPermission={myPermission} />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum procedimento encontrado</p>
                        <p className="pg-empty-subtitle">
                            {procedures.length === 0
                                ? 'Cadastre o primeiro procedimento para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={80}
                content={
                    <NewProcedure
                        btCancelAction={() => setModalNew(false)}
                        handleOnSuccess={() => { setModalNew(false); getAll() }}
                    />
                }
            />

        </section>
    )
}

export default Procedure
